'use strict';

export default class Confetti{

	#count
	#infinity
	#duration;
	#colors;
	#animations;

	#wrapper;
	#confettiWrapper;
	#styleElement;

	#initialized = false;

	constructor(count, duration = 4000, infinity = false, colors = ['#d13447', '#ffbf00', '#263672']) {
		this.#count = count;
		this.#duration = duration;
		this.#infinity = infinity;
		this.#colors = colors;

		this.#animations = '';
	}

	initialize() {
		if (this.#initialized) return;

		this.#initialized = true;
		this.#wrapper = document.createElement('section');
		this.#wrapper.style.position = 'fixed';
		this.#wrapper.style.width = '100dvw';
		this.#wrapper.style.height = '0';
		this.#wrapper.style.top = '0';
		this.#wrapper.style.left = '0';
		this.#wrapper.style.zIndex = '9999999999999999';
		this.#wrapper.style.pointerEvents = 'none';

		this.#confettiWrapper = document.createElement('div');
		this.#confettiWrapper.style.position = 'relative';
		this.#confettiWrapper.style.width = '100dvw';
		this.#confettiWrapper.style.height = '0';

		this.#wrapper.append(this.#confettiWrapper);

		for (let i = 0; i < this.#count; i++) {
			const width = this.#rand(10, 20),
				height = width * this.#rand(0,0.7),
				left = this.#rand(0, 100),
				color = this.#colors[Math.round(this.#rand(0,this.#colors.length - 1))],
				opacity = this.#rand(.8, 1),
				rotate3d = 0;

			const timing = this.#pieceTiming(i);
			const iteration = this.#infinity ? ' infinite' : ' forwards';
			const style = `
				width: ${width}px;
				height: ${height}px;
				left: ${left}%;
				background: ${color};
				opacity: ${opacity};
				border-radius: ${width / 7.5}px;
				transform: translateY(-10dvw) rotateX(${this.#rand(-180, 180)}deg) rotateY(${this.#rand(-720, 720)}deg) rotateZ(${this.#rand(-1440, 1440)}deg);
				position: absolute;
				display: block;
				pointer-events: none;
				animation: confetti-animation-${i} linear ${timing.duration}s${iteration} ${timing.delay}s
			`;

			this.#confettiWrapper.innerHTML += `<span class="confetti confetti-${i}" style="${this.#compressCSS(style)}"></span>`;

			this.#animations += `
				@keyframes confetti-animation-${i} {
					100% {
						left: ${left + this.#rand(-15, 15)}%;
						transform: translateY(150dvh) rotateX(${this.#rand(0, 180)}deg) rotateY(${this.#rand(0, 720)}deg) rotateZ(${this.#rand(0, 1440)}deg);
					}
				}
			`
		}

		const style = document.createElement('style');
		style.textContent = this.#compressCSS(this.#animations);
		this.#styleElement = style;

		document.head.append(style)

		document.body.append(this.#wrapper);

		if (!this.#infinity) {
			window.setTimeout(() => {
				this.#wrapper?.remove();
				this.#styleElement?.remove();
			}, this.#duration);
		}

		this.#initialized = true;
	}

	#pieceTiming(index) {
		if (this.#infinity) {
			return {
				duration: (this.#duration + this.#rand(0, this.#duration / 2)) / 1000,
				delay: index / 50 + this.#rand(0, 1),
			};
		}

		const budget = this.#duration / 1000;
		const maxDelay = Math.min(1, budget * 0.25);
		const delay = this.#rand(0, maxDelay);

		return {
			duration: parseFloat((budget - delay).toFixed(2)),
			delay,
		};
	}

	#rand(min, max) {
		return parseFloat((min + Math.random() * (max - min)).toFixed(2));
	}

	#compressCSS(css) {
		return css.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, '')
			.replace(/ {2,}/g, ' ')
			.replace(/ ([{:}]) /g, '$1')
			.replace(/([;,]) /g, '$1')
			.replace(/ !/g, '!');
	}
}
